"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateFieldView = void 0;
const tslib_1 = require("tslib");
// @todo deprecate use of time-stamp and use moment
const time_stamp_1 = tslib_1.__importDefault(require("time-stamp"));
const index_1 = require("../../../i18n/index");
const services_1 = require("../../../services");
exports.DateFieldView = {
    viewInline(field) {
        if (!field.hasValue()) {
            return '';
        }
        const date = new Date(field.value);
        if (field.value == null || isNaN(date.getTime())) {
            return (0, index_1.Translate)(index_1.T.DATE_INVALID);
        }
        return (0, time_stamp_1.default)(services_1.Services.UserSettings.dateFormat, date);
    },
    viewDetail(field) {
        return null;
    },
    viewEdit(field, state) {
        return this.viewInline(field, state);
    },
};
//# sourceMappingURL=date.field.view.js.map